import { render } from "./EducationView.vue?vue&type=template&id=6b75ffc2&scoped=true"
import script from "./EducationView.vue?vue&type=script&lang=js"
export * from "./EducationView.vue?vue&type=script&lang=js"

import "./EducationView.vue?vue&type=style&index=0&id=6b75ffc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b75ffc2"]])

export default __exports__